import {Component, OnInit, ChangeDetectorRef, OnDestroy, AfterViewInit} from '@angular/core';
import {SongsService, AuthService} from '../api/';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {ScrollService, ScrollParams, SearchService, BasicSearchParams} from '../api';
import * as _ from 'lodash';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {PlayerService} from '../player/services/player.service';
import {Helper} from '../helper';
import { Location } from '@angular/common';
import { Globals } from '../app.globals';
declare var $: any;

@Component({
    selector: 'songs',
    templateUrl: './songs.component.html',
    styleUrls: ['./songs.component.css']
})
export class SongsComponent implements OnInit, OnDestroy {
    private type: string = '';
    private subtype: string = '';
    private title: string = '';
    private searchPlaceholder = 'Search ';
    private songs: Array<any>;
    private songsTemp: Array<any>;
    private scrollParams = new ScrollParams();
    private searchTerm: string = '';
    private searchType: string = '';
    private lastTerm: string = '';
    private scrollSubscriber = null;
    public creditsArray: any = [];
    public writersArray: any = [];
    private helper = new Helper();
    private loading: boolean = true;
    private itsfromAdvancedSearch: boolean = false;
    private ifMobile: boolean = false;
    private totalRecords: number = 0; // for search see all count
    private viewAsList = 1;
    private sortedColumn = null;
    private limit: number = 10;
    private lyricSlice: number = 400;
    @BlockUI() blockUI: NgBlockUI;
    public slideIndex = 1;
    public interval = 0;
    song: any;
    checkIfFromArtis: boolean = true;
    private count = 0;
    public onlineOffline: boolean = navigator.onLine;
    public searchResult: any = [];
    public isAvailable: boolean = false;
    public category: string;
    // to manage the multiple calls
    enableScrollForMostPlayed = true;
    enableScrollForMostDownloaded = true;
    enableScrollForNewestMusic = true;
    enableScrollForCreditSearch = true;
    public apiUrl: string = new Globals().apiEndpoint;
    public missingRecords: number = 0;
    public enableScrollForSearch: boolean = true;
    private columnArr = [
        {title: 'C', key: 'album', type: 'image', width: '120px', isSortable: true, responsiveIndex: 'all'},
        {
            title: 'Artist',
            key: 'artist.name',
            type: 'anchor',
            width: '220px',
            textStyle: ['my-music-artist'],
            responsiveIndex: 'gt-md'
        },
        {
            title: 'Name',
            key: 'name',
            type: 'anchor',
            width: '350px',
            textStyle: ['my-music-name'],
            responsiveIndex: 'all'
        },
        {title: 'Genres', key: 'genre', type: 'genre', width: '', responsiveIndex: 'gt-md'},

    ];
    enableElasticSearch: boolean = false;

    constructor(private location: Location,private authService: AuthService, private playerService: PlayerService, private songsService: SongsService, private route: ActivatedRoute, private cdRef: ChangeDetectorRef,
    private scrollService: ScrollService, private router: Router, private searchService: SearchService) {
        window.addEventListener('online', () => {this.onlineOffline = true;
            this.songsService.getCall().toPromise().then((res) => {
            }).catch((err) => {
                this.onlineOffline = false;
                this.blockUI.stop();
            });});
        window.addEventListener('offline', () => {this.onlineOffline = false});
        localStorage.setItem("radio", '0');
        this.songs = new Array<any>();
        this.route.queryParams.subscribe((queryParams: any) => {
            this.searchType = "";
            this.searchTerm = queryParams.q;
            this.searchType = queryParams.type;
            this.subtype = queryParams.subtype;
            this.totalRecords = queryParams.total;
            this.songs = new Array<any>();
            this.scrollParams.page = 1;
            this.getSongsByType();
        });
        if (this.route.snapshot.data['title']) {
            this.title = this.route.snapshot.data['title'];
            this.searchPlaceholder += this.title;
        }
        if (this.route.snapshot.data['type']) {
            this.type = this.route.snapshot.data['type'];
        }
    }

    ngOnInit() {
        if(screen.width <= 1024) {
            this.lyricSlice = 200;
        } else if(screen.width <= 1400) {
            this.lyricSlice = 450;
        } else if(screen.width <= 3070) {
            this.lyricSlice = 550;
        } else {
            this.lyricSlice = 700;
        }
        if(screen.width < 768) {
            this.ifMobile = true ;
            this.columnArr = [
                {title: 'C', key: 'album', type: 'image', width: '120px', isSortable: true, responsiveIndex: 'all'},
                {
                    title: 'Artist',
                    key: 'artist.name',
                    type: 'anchor',
                    width: '220px',
                    textStyle: ['my-music-artist'],
                    responsiveIndex: 'gt-md'
                },
                {
                    title: 'Name',
                    key: 'name',
                    type: 'anchor',
                    width: '350px',
                    textStyle: ['my-music-name'],
                    responsiveIndex: 'all'
                },
            ];
        }
        this.route.queryParams.subscribe((queryParams: any) => {
            this.searchType = "";
            this.searchTerm = queryParams.q;
            this.searchType = queryParams.type;
            this.subtype = queryParams.subtype;
            this.totalRecords = queryParams.total;
            this.songs = new Array<any>();
            this.scrollParams.page = 1;
            this.getSongsByType();
        });
        if (localStorage.getItem("viewAsList") == "1") {
            this.viewAsList = 1;
        }
        if (localStorage.getItem("viewAsList") == "2") {
            this.viewAsList = 2;
        }
        if (localStorage.getItem("viewAsList") == "3") {
            this.viewAsList = 3;
        }
        this.scrollSubscriber = this.scrollService.onScroll.subscribe((event) =>  this.getSongsByType());
    }

    //back to previous url-- Only for advanced search
    back() {
        this.location.back();
    }

    deleteLocal() {
        var type = '';
        if (this.type === 'MP') {
            type = 'mostPlayed';
            localStorage.removeItem(type);
        } else if (this.type === 'NM') {
            type = 'mostNew';
            localStorage.removeItem(type);
        } else if (this.type === 'MD') {
            type = 'mostDownload';
            localStorage.removeItem(type);
        }
        this.songs = new Array<any>();
        this.scrollParams.page = 1;
        this.getSongsByType();
    }

    getSongsByType() {
        if (this.searchType == "AS") {
            this.type="AS";
        }
        if (this.searchType == "credits") {
            this.type="credits";
        }
        if (this.searchType == "" || this.searchType == "search") {
            this.type="search";
        }
        this.count = 0;

        if (this.lastTerm !== this.searchTerm) {
            this.resetScrollParams();
            this.lastTerm = this.searchTerm;
            this.songs = new Array<any>();
        }
        if(this.type === 'MP') {
            this.blockUI.start('Loading, please wait...');
            this.getMostPlayed()
        } else if(this.type === 'NM') {
            this.blockUI.start('Loading, please wait...');
            this.getMusicLibrary();
        } else if(this.type === 'MD') {
            this.blockUI.start('Loading, please wait...');
            this.getMostdownload();
        } else if(this.type === 'AS') {
            this.getCreditsSearch();
        } else if(this.type === 'credits') {
            let productioncreditsdata = [];
            this.blockUI.start('Loading, please wait...');
            let params = new BasicSearchParams(true, false, false);
            if(this.onlineOffline == false)
                return ;

            this.songsService.getSongsfromlblwrtrpblsh(this.searchTerm, this.limit,this.scrollParams.page).toPromise().then((res) => {
                productioncreditsdata = res.songs;
                this.totalRecords = res.total;
                if(productioncreditsdata.length > res.total){
                    this.totalRecords = productioncreditsdata.length;
                }

                productioncreditsdata.forEach((arrayItem) => {
                    let song: any = _.pick(arrayItem.song, ['name', 'artist', 'album', 'slug','id']);
                    song._type = "song";
                    if(typeof this.songs.push == "function"){
                        if(song.name){
                            this.songs.push(song);
                        }
                    }
                });

                this.searchService.getSearchResults(this.searchTerm, params, this.scrollParams).then((res: any) => {
                    if(res.total > this.totalRecords) {
                        this.totalRecords = res.total;
                    }
                    if (res.total > 0) {
                        if (res.data != null && res.data.song != null && res.data.song.length > 0) {
                            res.data.song.forEach((arrayItem) => {
                                if (arrayItem._source.lyrics != null && arrayItem._source.lyrics != "") {
                                    arrayItem._source.songLyrics = arrayItem._source.lyrics;
                                    arrayItem._source.songLyrics2 = arrayItem._source.songLyrics.slice(0, this.lyricSlice);
                                }
                                if (arrayItem._source.genres && arrayItem._source.genres.name) {
                                    arrayItem._source.genre = arrayItem._source.genres.name;
                                } else {
                                    arrayItem._source.genre = "";
                                }
                                arrayItem._source._type = "song"
                                arrayItem._source.active = 1;
                                this.songs.push(arrayItem._source);
                            });
                            this.songs = _.uniqBy(this.songs, 'id');

                        }
                    }
                    this.songs = [].concat(this.songs ,productioncreditsdata)
                    this.songs = _.uniqBy(this.songs, 'id');
                    this.blockUI.stop();
                    this.cdRef.detectChanges();
                    this.removeSlash();
                    this.removeDuplicatCredits();
                });
            })
            .catch((err) => {
            });
            this.scrollParams.page++;
        } else if (this.type === 'search') {
            if(this.enableScrollForSearch) {
                this.enableScrollForSearch = false;
                let productioncreditsdata = [];
                this.blockUI.start('Loading, please wait...');
                let params;
                if (this.searchType == "like") {
                    let soundslikedata = [];
                    params = new BasicSearchParams(false, false, false, false, false, true, false);
                    let quickSearch = 'no';
                    this.songsService.getSoundsLikefromdb(this.searchTerm, quickSearch, this.scrollParams.page).subscribe(res => {
                        if(res['songs'].length > 0) {
                            soundslikedata =  res['songs'];
                            this.totalRecords = res['totalCount'];
                            if(!res['songs'] && this.enableElasticSearch) {
                                this.searchService.getSearchResults(this.searchTerm, params).then((res: any) => {
                                    if(res) {
                                        if(res.total > this.totalRecords) {
                                            this.totalRecords = res.total;
                                        }
                                        if (res.total > 0) {
                                            if (res.data != null && res.data.song != null && res.data.song.length > 0) {
                                                res.data.song.forEach((arrayItem) => {
                                                    if (arrayItem._source.lyrics != null && arrayItem._source.lyrics != "") {
                                                        arrayItem._source.songLyrics = arrayItem._source.lyrics;
                                                        arrayItem._source.songLyrics2 = arrayItem._source.songLyrics.slice(0, this.lyricSlice);
                                                    }
                                                    if (arrayItem._source.genres && arrayItem._source.genres.name) {
                                                        arrayItem._source.genre = arrayItem._source.genres.name;
                                                    } else {
                                                        arrayItem._source.genre = "";
                                                    }
                                                    arrayItem._source._type = "song"
                                                    arrayItem._source.active = 1;
                                                    this.songs.push(arrayItem._source);
                                                });
                                                this.songs = _.uniqBy(this.songs, 'id');
                                            }
                                        }
                                    }
                                });
                            }
                            this.scrollParams.page++;
                            this.enableScrollForSearch = true;
                            this.songs = [].concat(this.songs, soundslikedata)
                            this.songs = _.uniqBy(this.songs, 'id');
                            this.blockUI.stop();
                            this.cdRef.detectChanges();
                        } else {
                            this.enableScrollForSearch = false;
                            this.blockUI.stop();
                        }
                    });
                    return;
                } else if (this.searchType == "credits") {
                    params = new BasicSearchParams(false, false, false, false, false, false, true);
                } else {
                    params = new BasicSearchParams(true, false, false);
                }
                if(this.onlineOffline == false)
                    return ;

                let quickSearch = 'no';
                this.songsService.getSongsfromdb(this.searchTerm, quickSearch, this.scrollParams.page).toPromise().then((res) => {
                    if(res['songs'].length > 0) {
                        productioncreditsdata = res['songs'];
                        this.totalRecords = res['totalCount'];
                        if(!res['songs'] && this.enableElasticSearch) {
                            this.searchService.getSearchResults(this.searchTerm, params, this.scrollParams).then((res: any) => {
                                if (res) {
                                    if(res.total > this.totalRecords) {
                                        this.totalRecords = res.total;
                                    }
                                    if (res.total > 0) {
                                        if (res.data != null && res.data.song != null && res.data.song.length > 0) {
                                            res.data.song.forEach((arrayItem) => {
                                            if (arrayItem._source.lyrics != null && arrayItem._source.lyrics != "") {
                                                arrayItem._source.songLyrics = arrayItem._source.lyrics;
                                                arrayItem._source.songLyrics2 = arrayItem._source.songLyrics.slice(0, this.lyricSlice);
                                            }
                                            if (arrayItem._source.genres && arrayItem._source.genres.name) {
                                                arrayItem._source.genre = arrayItem._source.genres.name;
                                            } else {
                                                arrayItem._source.genre = "";
                                            }
                                            arrayItem._source._type = "song"
                                            arrayItem._source.active = 1;
                                            this.songs.push(arrayItem._source);
                                            });
                                            this.songs = _.uniqBy(this.songs, 'id');

                                        }
                                    }
                                }
                            });
                        }
                        this.enableScrollForSearch = true;
                        this.songs = [].concat(this.songs, productioncreditsdata)
                        this.songs = _.uniqBy(this.songs, 'id');
                        this.blockUI.stop();
                        this.cdRef.detectChanges();
                    } else {
                        this.enableScrollForSearch = false;
                        this.blockUI.stop();
                    }
                }).catch((err) => {
                    this.blockUI.stop();
                });
                this.scrollParams.page++;
            }
        }
        if(!this.onlineOffline) {
            this.blockUI.stop();
            this.loading = false;
        }
    }

    getCreditsSearch() {
        this.itsfromAdvancedSearch =  true;
        if(this.onlineOffline == false)
            return ;
        if(this.enableScrollForCreditSearch) {
            this.blockUI.start('Loading, please wait...');
            this.enableScrollForCreditSearch = false;
            this.songsService.searchCredits(this.searchTerm, this.subtype, this.limit,this.scrollParams.page).subscribe((res) => {
                if (res.length > 0) {
                    res.forEach((arrayItem) => {
                        let song = arrayItem;
                        if(song) {
                            if (song.lyrics != null) {
                                song.songLyrics = song.lyrics;
                                song.songLyrics2 = song.songLyrics.slice(0, this.lyricSlice);
                            }
                            song._type = "song";
                            this.songs.push(song);
                        }
                    });
                    this.songs = _.uniqBy(this.songs, 'id');
                    this.blockUI.stop();
                    this.loading = false;
                    this.removeSlash();
                    this.removeDuplicatCredits();
                    this.songsTemp = this.songs;
                    this.enableScrollForCreditSearch = true;
                    if(this.scrollParams.page < 4) {
                        this.getCreditsSearch()
                    }
                } else {
                    this.blockUI.stop();
                    this.loading = false;
                    this.enableScrollForCreditSearch = false;
                }
            },
            (error) => {
                console.log(error);
            });
            this.scrollParams.page++;
        }
    }

    getMostPlayed() {
        this.loading = true;
        let type = 'mostPlayed';
        if (this.localStore(type)) {
            if(this.onlineOffline == false)
                return ;
            if(this.enableScrollForMostPlayed) {
                this.enableScrollForMostPlayed = false;
                /*New common function*/
                var that = this;
                let queryParams = '';
                queryParams += 'page=' + this.scrollParams.page+"&limit="+this.limit;;
                if (this.sortedColumn && this.sortedColumn.key) {
                    queryParams += '&sortBy=' + this.sortedColumn.key + '&sortOrder=' + this.sortedColumn.sortOrder;
                }
                if(this.searchTerm!='' && this.searchTerm != null){
                    queryParams += '&q=' + this.searchTerm;
                }
                $.get(this.apiUrl+"songs/most-played?" + queryParams).done((res) => {
                    this.commonFunc(res, type);
                });

                this.scrollParams.page++;
            } else{
              this.blockUI.stop();
            }
        } else{
          this.blockUI.stop();
        }
    }

    getMostdownload() {
        this.loading = true;
        let type = 'mostDownload';
        if (this.localStore(type)) {
            if(this.onlineOffline == false)
                return ;
            if(this.enableScrollForMostDownloaded) {
                this.enableScrollForMostDownloaded = false;
                var that = this;
                let queryParams = '';
                queryParams += 'page=' + this.scrollParams.page+"&limit="+this.limit;;
                if (this.sortedColumn && this.sortedColumn.key) {
                    queryParams += '&sortBy=' + this.sortedColumn.key + '&sortOrder=' + this.sortedColumn.sortOrder;
                }
                if(this.searchTerm!='' && this.searchTerm != null){
                    queryParams += '&q=' + this.searchTerm;
                }
                $.get(this.apiUrl+"songs/most-downloaded?" + queryParams).done((res) => {
                    this.commonFunc(res, type);
                });
                this.scrollParams.page++;
            } else{
              this.blockUI.stop();
            }
        } else{
          this.blockUI.stop();
        }
    }

    commonFunc(res, type){
        if (res.songs.length > 0) {
            this.enableScrollForMostPlayed = true;
            this.enableScrollForMostDownloaded = true;
            this.totalRecords = res.totalSongs;
            res.songs.forEach((arrayItem) => {
                let song = arrayItem;
                if(song){
                    if (song.lyrics != null) {
                        song.songLyrics = song.lyrics;
                        song.songLyrics2 = song.songLyrics.slice(0, this.lyricSlice);
                    }
                    this.songs.push(song);
                }
            });
            this.songs = _.uniqBy(this.songs, 'id');
            if(this.songs.length < 20) {
                this.totalRecords = this.songs.length;
            }
            this.loading = false;
            this.removeSlash();
            this.removeDuplicatCredits();
            this.songsTemp = this.songs;
            this.setLocalStore(type);
            this.blockUI.stop();
            if(this.scrollParams.page < 4 && type == 'mostDownload') {
                this.enableScrollForMostDownloaded = true;
                this.getMostdownload();
            } else if(this.scrollParams.page < 4 && type == 'mostPlayed') {
                this.enableScrollForMostPlayed = true;
                this.getMostPlayed();
            }
        } else {
          this.loading = false;
          this.blockUI.stop();
          this.enableScrollForMostDownloaded = false;
          this.enableScrollForMostPlayed = false;
        }
    }

    getMusicLibrary() {
        this.loading = true;
        let type = 'mostNew';
        if (this.songs.length < 200) {
            this.loading = true;
            if (this.localStore(type)) {
                if(this.onlineOffline == false)
                    return ;
                if(this.enableScrollForNewestMusic) {
                    this.enableScrollForNewestMusic = false;
                    var that = this;
                    let queryParams = '';
                    queryParams += 'page=' + this.scrollParams.page;
                    if (this.sortedColumn && this.sortedColumn.key) {
                        queryParams += '&sortBy=' + this.sortedColumn.key + '&sortOrder=' + this.sortedColumn.sortOrder;
                    }
                    if(this.searchTerm!=''){
                        queryParams += '&name=' + this.searchTerm;
                    }
                    $.get(this.apiUrl+"songs/newest?" + queryParams).done(
                        function(res) {
                            if (res.songs.length > 0) {
                                that.totalRecords = res.totalSongs;
                                res.songs.forEach((arrayItem) => {
                                if (that.songs.length < 200) {
                                    if (arrayItem.lyrics != null) {
                                        arrayItem.songLyrics = arrayItem.lyrics;
                                        arrayItem.songLyrics2 = arrayItem.songLyrics.slice(0, that.lyricSlice);
                                    }
                                    that.songs.push(arrayItem);
                                }
                            });
                                that.songs = _.uniqBy(that.songs, 'id');
                            if(res.totalSongs < 200) {
                                that.totalRecords = that.songs.length;
                            } else {
                                that.totalRecords = 200;
                            }
                                localStorage.setItem("totalRecords" , JSON.stringify(that.totalRecords));
                                that.blockUI.stop();
                                that.enableScrollForNewestMusic = true;
                            } else {
                                that.enableScrollForNewestMusic = false;
                            }
                            that.scrollService.toggleProgressBar(false);
                            that.loading = false;
                            that.cdRef.detectChanges();
                            that.removeSlash();
                            that.removeDuplicatCredits();
                            that.songsTemp = that.songs;
                            that.setLocalStore(type);
                            if(that.scrollParams.page < 4) {
                                that.getMusicLibrary()
                            }
                        }
                    ).fail((res)=>{
                        that.scrollService.toggleProgressBar(false);
                        that.loading = false;
                        that.blockUI.stop();
                    });
                    this.scrollParams.page++;
                }
            } else {
                this.totalRecords = JSON.parse(localStorage.getItem("totalRecords"));
            }
        } else {
            this.loading = false;
            this.cdRef.detectChanges();
            setTimeout(() => {
                this.blockUI.stop();
            }, 2000)
        }
    }

    localStore($type) {
        if(this.helper.localTimeCheck(this.onlineOffline)){
            return true;
        }
        if(this.scrollParams.page >3){
            return true;
        }
        let songs = JSON.parse(localStorage.getItem($type));
        if(JSON.parse(localStorage.getItem($type + "records"))) {
            this.totalRecords = JSON.parse(localStorage.getItem($type + "records"));
        }
        if(songs != null && songs.length>0) {
            this.scrollParams.page = Math.ceil(songs.length / this.limit);
            this.scrollParams.page++;
            this.songsService.getCall().toPromise().then((res) => {
                this.songs = songs;
                this.songsTemp = this.songs;
                this.blockUI.stop();
            }).catch((err) => {
                this.songs = songs;
                this.songsTemp = this.songs;
                this.blockUI.stop();
            });
            if(songs.length < 30) {
                return true;
            }
            return false
        } else {
            return true;
        }
    }

    setLocalStore($type) {
        localStorage.setItem($type, JSON.stringify(this.songs));
        localStorage.setItem($type + "records", JSON.stringify(this.totalRecords));
    }

    removeSlash() {
        if (this.songs) {
            for (var i = 0; i < this.songs.length; i++) {
                if (typeof this.songs[i].credits === "object" && this.songs[i].credits != null) {
                    for (var j = 0; j < this.songs[i].credits.length; j++) {
                        this.songs[i].credits[j].credit_type = this.songs[i].credits[j].credit_type.replace("_", " ");
                        this.songs[i].credits[j].credit_type = this.songs[i].credits[j].credit_type.charAt(0).toUpperCase() + this.songs[i].credits[j].credit_type.slice(1);
                    }
                }
            }
        }
    }

    removeDuplicatCredits() {
        for (let i = 0; i < this.songs.length; i++) {
            this.writersArray = new Array<any>();
            for (let e = 0; e < 4; e++) {
                if (typeof this.songs[i].writers === "object" && this.songs[i].writers != null) {
                    this.songs[i].writers.forEach((item, index) => {
                        if (index !== this.songs[i].writers.findIndex(i => i.writer === item.writer)) {
                            this.writersArray.push(this.songs[i].writers[index]);
                            this.songs[i].writers.splice(index, 1);
                        }
                    });
                }
            }
            for (let f = 0; f < 4; f++) {
                this.creditsArray = new Array<any>();
                if (typeof this.songs[i].credits === "object" && this.songs[i].credits != null) {
                    this.songs[i].credits.forEach((item, index) => {
                        if (index !== this.songs[i].credits.findIndex(i => i.credit_type === item.credit_type)) {
                            this.creditsArray.push(this.songs[i].credits[index]);
                            this.songs[i].credits.splice(index, 1);
                        }
                    });
                }
            }
            for (let j = 0; j < this.creditsArray.length; j++) {
                for (let k = 0; k < this.songs[i].credits.length; k++) {
                    if (this.songs[i].credits[k].credit_type == this.creditsArray[j].credit_type) {
                        if (!(this.songs[i].credits[k].name.includes(this.creditsArray[j].name))) {
                            if (!this.songs[i].credits[k].values) {
                                this.songs[i].credits[k]["values"] = [];
                            }
                            if (!(this.songs[i].credits[k].values.includes(this.songs[i].credits[k].name))) {
                                this.songs[i].credits[k].values.push(this.songs[i].credits[k].name);
                            }
                            if (!(this.songs[i].credits[k].values.includes(this.creditsArray[j].name))) {
                                this.songs[i].credits[k].values.push(this.creditsArray[j].name);
                            }
                        }
                    }
                }
            }
            if (typeof this.songs[i].credits === "object" && this.songs[i].credits != null) {
                for (let k = 0; k < this.songs[i].credits.length; k++) {
                    if (!this.songs[i].credits[k].values) {
                        this.songs[i].credits[k]["values"] = [];
                    }
                    if (!(this.songs[i].credits[k].values.includes(this.songs[i].credits[k].name))) {
                        let locationPartt = this.songs[i].credits[k].name.split(",");
                        for (let p = 0; p < locationPartt.length; p++) {
                            locationPartt[p].replace(",", "");
                            this.songs[i].credits[k].values.push(locationPartt[p]);
                        }
                    }
                    if (this.songs[i].credits[k].location && this.songs[i].credits[k].location != null) {
                        this.songs[i].credits[k]["locations"] = [];
                        let locationParts = this.songs[i].credits[k].location.split(",");
                        for (let m = 0; m < locationParts.length; m++) {
                            if (!(locationParts[m].includes("."))) {
                                this.songs[i].credits[k].locations.push(locationParts[m]);
                            }
                            else {
                                let locationParts2 = locationParts[m].split(".");
                                for (let n = 0; n < locationParts2.length; n++) {
                                    this.songs[i].credits[k].locations.push(locationParts2[n]);
                                }
                            }
                        }
                    }
                }
            }

            //publisher array making
            if (!this.songs[i].publishers) {
                this.songs[i]["publisherss"] = [];
                if (this.songs[i].publisher) {
                    var locationParttt = this.songs[i].publisher.split(",");
                    for (let p = 0; p < locationParttt.length; p++) {
                        locationParttt[p].replace(",", "");
                        this.songs[i].publisherss.push(locationParttt[p]);
                    }
                }
            } else {
                this.songs[i]["publisherss"] = [];
                for (let m = 0; m < this.songs[i].publishers.length; m++) {
                    if (this.songs[i].publishers[m].publisher) {
                        this.songs[i].publisherss.push(this.songs[i].publishers[m].publisher);
                    }
                }
            }
        }

    }

    sortColumn(event, type) {
        if (type == "MP") {
            this.blockUI.start('...');
            this.sortedColumn = event;
            this.scrollParams = new ScrollParams();
            this.songs = new Array<any>();
            this.getMostPlayed();
        } else if (type == "MD") {
            this.blockUI.start('Loading, please wait...');
            this.sortedColumn = event;
            this.scrollParams = new ScrollParams();
            this.songs = new Array<any>();
            this.getMostdownload();
        } else {
            this.blockUI.start('Loading, please wait...');
            this.sortedColumn = event;
            this.scrollParams = new ScrollParams();
            this.songs = new Array<any>();
            this.getMusicLibrary();
        }

    }

    toggleViewAsList(value) {
        this.viewAsList = value;
        localStorage.setItem("viewAsList", value);
        if (this.viewAsList == 3) {
            if (document.getElementById('Ui123456') != null) {
                document.getElementById('Ui123456').style.overflowY = 'initial';
                document.getElementById('Ui123456').className = 'app-content2';
            }
            if (document.getElementById('Ui12345') != null) {
                document.getElementById('Ui12345').className = 'app-content2';
            }
            if (this.scrollSubscriber != null) {
                this.scrollSubscriber.unsubscribe();
                this.scrollSubscriber = null;
            }
        }
        if(this.viewAsList != 3) {
            if (document.getElementById('Ui123456') != null) {
                document.getElementById('Ui123456').className = 'app-content';
            }
            if (document.getElementById('Ui12345') != null) {
                document.getElementById('Ui12345').className = 'app-content';
            }
            if (this.scrollSubscriber == null) {
                this.scrollSubscriber = this.scrollService.onScroll.subscribe((event) =>  this.getSongsByType());
            }
        }
    }

    handleSearchs(event) {
        this.searchTerm = event.searchTerm;
        let navigationExtras: NavigationExtras = {
            relativeTo: this.route,
            queryParams: {'q': this.searchTerm},
        };
        this.getSongsByType();
        this.router.navigate([], navigationExtras);
    }

    handleSearch(event) {
        this.loading = true;
        this.searchTerm = event.searchTerm;
        let navigationExtras: NavigationExtras = {
            relativeTo: this.route,
            queryParams: {'q': this.searchTerm},
        };
        if (this.songsTemp) {
            if (this.route.snapshot.data['type'] == "NM") {
                this.blockUI.start('Loading, please wait...');
            }
            this.songs = new Array<any>();
            if (this.searchTerm != "") {
                for (var i = 0; i < this.songsTemp.length; i++) {
                    var namee = "", artistt = "", genree = "";
                    if (this.songsTemp[i].name != null) {
                        namee = this.songsTemp[i].name.toUpperCase();
                    }
                    if (this.songsTemp[i].artist && this.songsTemp[i].artist.name != null) {
                        artistt = this.songsTemp[i].artist.name.toUpperCase();
                    }
                    if (this.songsTemp[i].genres) {
                        this.songsTemp[i].genres.forEach(element => {
                            genree += element.name.toUpperCase() + ",";
                        });
                    }
                    if (namee) {
                        if (namee.indexOf(this.searchTerm.toUpperCase()) > -1) {
                            this.songs.push(this.songsTemp[i]);
                        }
                    }
                    if (artistt) {
                        if (artistt.indexOf(this.searchTerm.toUpperCase()) > -1) {
                            this.songs.push(this.songsTemp[i]);
                        }
                    }
                    if (genree) {
                        if (genree.indexOf(this.searchTerm.toUpperCase()) > -1) {
                            this.songs.push(this.songsTemp[i]);
                        }
                    }
                }
                this.songs = _.uniqBy(this.songs, 'id');
            } else {
                this.songs = this.songsTemp;
            }
        }
        if (this.route.snapshot.data['type'] == "NM") {
            setTimeout(() => {
                this.blockUI.stop();
            }, 500);
        }
        this.loading = false;
        // to check if the songs exists other than the current category
        if (this.songs.length == 0) {
            this.songsService.checkAllSongs(this.searchTerm).subscribe(res => {
                if(res) {
                    this.searchResult = res;
                    this.isAvailable = true;
                    if (this.type == 'MD') {
                        this.category = 'Downloaded Yet';
                    } else if (this.type == 'MP') {
                        this.category = 'Played Yet';
                    } else if (this.type == 'NM') {
                        this.category = 'the Newest One';
                    }
                } else {
                    this.isAvailable = false;
                }
            });
        }
    }

    resetScrollParams() {
        this.scrollParams = new ScrollParams();
    }

    ngOnDestroy() {
        if (this.scrollSubscriber != null) {
            this.scrollSubscriber.unsubscribe();
        }
    }

    refreshList() {
        this.getSongsByType();
    }

    mouseHovering(index) {
        this.songs[index].isHovering = true;
    }

    mouseLeaving(index) {
        this.songs[index].isHovering = false;
    }

    // to show more results of the search query if not exists in specific category
    onMoreResults(type: string,subtype:string="") {
        if(subtype == "") {
            subtype = "search";
        }
        let navigationExtras: NavigationExtras = {
            queryParams: { 'q': this.searchTerm,'type': subtype},
        };
        if (type === 'songs') {
            this.router.navigate(['/songs'], navigationExtras);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/songs/songs.component.ts